<er-base-confirm-prompt
  title="{{ i18Cmp + '.title' | transloco }}"
  cancelBtnLabel="{{ i18Cmp + '.close_button' | transloco }}"
  confirmBtnLabel="{{ i18Cmp + '.confirm_button' | transloco }}"
  icon="modal-red-question"
  [content]="content"
  [size]="BaseConfirmPromptSizeEnum.SM"
  (confirm)="onConfirmClick()"
  (close)="onCloseClick()"
>
</er-base-confirm-prompt>
<ng-template #content>
  {{ i18Cmp + ".content" | transloco }}
</ng-template>
